import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7ef699gcdg: FaireBrandEntity = {
  token: "b_7ef699gcdg",
  type: "brand",
  name: "Beads Creation",
  avatarUrl:
    "https://cdn.faire.com/fastly/ca34e1eeee55c71159d7804c0b7b7675b4ba87985c04e0c16ec27ac471b0411d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/97a1ae547dbd4f740ce71d1be661d65703bbfbf084e8acd3331060e8c8ea98df.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ca34e1eeee55c71159d7804c0b7b7675b4ba87985c04e0c16ec27ac471b0411d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/97a1ae547dbd4f740ce71d1be661d65703bbfbf084e8acd3331060e8c8ea98df.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 62,
  rating: 4.8,
  reviewCount: 226,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to our online jewelry component shop, a women-owned small business with over a decade of passion and experience. Our journey began with a dream, and through hard work and dedication, we've become trusted experts in the industry. As a female entrepreneur, our mission is not only to provide high-quality components but also to empower women in the world of jewelry crafting. We pride ourselves on our commitment to quality, unique designs, and exceptional customer service. Our vision is to continue growing and evolving, always staying true to our core values. Join us in this journey, and let's create something beautiful together.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:18.389Z",
    importedBy: "entity-db-cli",
  },
};
